var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$store.state.preload),expression:"$store.state.preload"}],staticClass:"preload"},[_c('div',{staticClass:"bgPreload"}),_c('v-progress-linear',{attrs:{"indeterminate":true,"height":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }